module.exports = __webpack_public_path__ + "static/media/black-cross-icon.93b7bf3f.svg";